module.exports = __webpack_public_path__ + "img/bg.d9ee04f1.png";